const routes = {
  adaptiveLearningAssessment: 'adaptive-learning',
  root: '/digital-delivery',
}

export default routes
